import { useMemo } from 'react'
import type { EntityResolvers } from '@factorialco/f0-react'
import { usePersonResolver } from './person/usePersonResolver'

export const useEntityResolvers = (): EntityResolvers => {
  const { person, searchPersons } = usePersonResolver()

  return useMemo(() => ({ person, searchPersons }), [person, searchPersons])
}
